import { gqlClient } from 'gql'

export const kUserPreferenceCacheUpdate = (kUserId: string, preferences: string) => {
  const cache = gqlClient.core.cache
  try {
    cache.modify({
      id: `KUser${kUserId}`,
      fields: {
        preferences: (_data) => preferences,
      },
    })
  } catch (err) {
    console.error('"kUserPreferenceCacheUpdate" fn is crashed on operation: ".modify"', err)
  }
}
